import { render, staticRenderFns } from "./ConfirmPay.vue?vue&type=template&id=79ff228a&scoped=true&"
import script from "./ConfirmPay.vue?vue&type=script&lang=js&"
export * from "./ConfirmPay.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPay.vue?vue&type=style&index=0&id=79ff228a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff228a",
  null
  
)

export default component.exports